import axios from 'axios';

// Detectar automáticamente la URL de la API según el host
const getApiUrl = () => {
  const host = window.location.hostname;

  // Si estamos en desarrollo local
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:5000';
  }

  // Para el dominio de producción efectofm.es
  if (host === 'www.efectofm.es' || host === 'efectofm.es') {
    // Si estamos en HTTPS, usar proxy a través del mismo dominio
    if (window.location.protocol === 'https:') {
      return ''; // Usar el mismo origen, las peticiones irán a /api
    }
    // Fallback para desarrollo
    return 'http://opalita.ec5w.es:5000';
  }

  // Para cualquier otro host (producción o acceso externo)
  // Usar el mismo host pero puerto 5000
  return `http://${host}:5000`;
};

// IMPORTANTE: La URL de la API siempre debe usar el host actual
const API_URL = getApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Interceptor para añadir el token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Helper function para obtener la URL correcta de imágenes
const getImageUrl = (path: string): string => {
  // Si el path ya es una URL completa, devolverla tal cual
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Si estamos en HTTPS en producción
  if (window.location.protocol === 'https:' &&
      (window.location.hostname === 'www.efectofm.es' || window.location.hostname === 'efectofm.es')) {
    // Las rutas estáticas como /parrilla y /uploads se sirven directamente
    return path;
  }

  // Para otros casos (desarrollo local), usar API_URL normal
  return `${API_URL}${path}`;
};

export { API_URL, getImageUrl };
export default api;